import React from 'react';
import { Field, reduxForm } from 'redux-form';
// import label from '../../utils/lngEn';
// import FormField from '../common/FormField';
// import Validate from '../common/formValidate';
import DropdownList from 'react-widgets/lib/DropdownList';
import { Col, Row, DropdownButton, MenuItem } from 'react-bootstrap';
const renderDropdownList = ({ input, meta: { touched, error }, ...rest }) => (
  <div>
    <DropdownList {...input} {...rest} />
    <div>{touched && (error && <span className="text-danger">{error}</span>)}</div>
  </div>
);

class SelectAssignmentForm extends React.Component {
  render() {
    return (
      <form className="assignment-data-form">
        <Row>
          <Col md={6}>
            <Field
              name="computationId"
              valueField="value"
              textField="option"
              data={this.props.computations}
              component={renderDropdownList}
            />
          </Col>
          <Col md={3}>
            <button className="btn btn-sec pull-right" onClick={this.props.handleAssignmentSummary()}>
              Summary
            </button>
          </Col>
          <Col md={3}>
            <DropdownButton bsStyle="btn btn-ter pull-right" title="Download" key={0} id={`dropdown-basic-${0}`}>
              <MenuItem eventKey="1" onClick={this.props.handleDownloadComputation('excel')}>
                Download Excel
              </MenuItem>
              <MenuItem eventKey="2" onClick={this.props.handleDownloadComputation('json')}>
                Download JSON
              </MenuItem>
            </DropdownButton>
          </Col>
        </Row>
      </form>
    );
  }
}

export default reduxForm({
  form: 'SelectAssignmentForm'
})(SelectAssignmentForm);



// WEBPACK FOOTER //
// ./src/components/runs/SelectAssignmentForm.js